<template>
    <v-container class="pa-5" fluid>
        <OrdersListDialog
            :is-open="ordersListDialog"
            :action-loading="ordersListLoading"
            @on-close="closeOrdersListDialog"
        />
        <page-title>
            Zamówienia
        </page-title>

        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Zamówienia nadane w czasie
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Zamówienia nadane w rozkładzie zmianowym i godzinowym.
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisOrdersSentOrders')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Zamówienia - realizacja na dzień
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Zamówienia zrealizowane w rozkładzie dziennym.
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisOrdersPlacedOrders')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Średnia ilość zamówień nadanych w rozkładzie tygodniowym
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Zamówienia nadane w rozkładzie godzinowym.
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisOrdersWeeklySentOrders')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Średnia ilość zamówień nadanych w rozkładzie miesięcznym
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Zamówienia nadane w rozkładzie godzinowym.
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisOrdersMonthlySentOrders')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Raport realizacji zamówienia
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Raport pokazujący przebieg prac nad zamówieniem
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="showOrdersListDialog"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"  
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Raport - produkcja w toku
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Zamówienia, dla których surowiec został wystawiony w jednym miesiącu a ich wysyłka nastąpiła w kolejnym
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisOrdersOrdersInProgress')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Zamówienia nadane w czasie - wersja prosta
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Zamówienia nadane w rozkładzie zmianowym i godzinowym.
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisOrdersSentOrdersSimple')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto fill-height"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-chart-line
                                    </v-icon>
                                    Raport statusów zamówień
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Report statusów zamówień filtrowanych po planowanej dacie wysyłki.
                                    </div>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <v-menu
                                                v-model="menuFrom"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template #activator="{on}">
                                                    <v-text-field
                                                        v-model="orderStatusesReportData.plannedSendDate__gte"
                                                        label="Od"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        solo
                                                        hide-details
                                                        append-icon
                                                        clearable
                                                        class="mt-0"
                                                        v-on="on"
                                                        @click:clear="clearOrderStatusesReportData('plannedSendDate__gte')"
                                                    >
                                                        <template slot="append-outer">
                                                            <div class="d-flex flex-wrap">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    class="mt-n2"
                                                                    data-sentry-label="Zmiana daty raportu"
                                                                    @click="getForwardDate('plannedSendDate__gte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-up
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    data-sentry-label="Zmiana daty raportu"
                                                                    @click="getBackwardDate('plannedSendDate__gte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-down
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="orderStatusesReportData.plannedSendDate__gte"
                                                    first-day-of-week="1"
                                                    @input="menuFrom = false"
                                                />
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-menu
                                                v-model="menuTo"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template #activator="{on}">
                                                    <v-text-field
                                                        v-model="orderStatusesReportData.plannedSendDate__lte"
                                                        label="Do"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        solo
                                                        hide-details
                                                        append-icon
                                                        clearable
                                                        class="mt-0"
                                                        v-on="on"
                                                        @click:clear="clearOrderStatusesReportData('plannedSendDate__lte')"
                                                    >
                                                        <template slot="append-outer">
                                                            <div class="d-flex flex-wrap">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    class="mt-n2"
                                                                    data-sentry-label="Zmiana daty raportu"
                                                                    @click="getForwardDate('plannedSendDate__lte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-up
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    data-sentry-label="Zmiana daty raportu"
                                                                    @click="getBackwardDate('plannedSendDate__lte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-down
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="orderStatusesReportData.plannedSendDate__lte"
                                                    first-day-of-week="1"
                                                    @input="menuTo = false"
                                                />
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        :disabled="!orderStatusesReportData.plannedSendDate__lte || !orderStatusesReportData.plannedSendDate__gte"
                                        @click="generateOrderStatusesReport"
                                    >
                                        Generuj raport
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card class="mx-auto fill-height">
                                <v-card-title>
                                    <v-icon left large>
                                        mdi-chart-line
                                    </v-icon>
                                    Raport wydruku Lieferschein
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Wydruki Lieferschein, filtrowane po dacie wygenerowania.
                                    </div>
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-menu
                                                v-model="menuLieferscheinFrom"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template #activator="{on}">
                                                    <v-text-field
                                                        v-model="lieferscheinReportData.createdAt__gte"
                                                        label="Od"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        solo
                                                        hide-details
                                                        append-icon
                                                        clearable
                                                        class="mt-0"
                                                        v-on="on"
                                                        @click:clear="clearLieferscheinReportData('createdAt__gte')"
                                                    >
                                                        <template slot="append-outer">
                                                            <div class="d-flex flex-wrap">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    class="mt-n2"
                                                                    data-sentry-label="Zmiana początku daty raportu - +1"
                                                                    @click="getLieferscheinForwardDate('createdAt__gte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-up
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    data-sentry-label="Zmiana początku daty raportu - -1"
                                                                    @click="getLieferscheinBackwardDate('createdAt__gte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-down
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="lieferscheinReportData.createdAt__gte"
                                                    first-day-of-week="1"
                                                    @input="menuLieferscheinFrom = false"
                                                />
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-menu
                                                v-model="menuLieferscheinTo"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template #activator="{on}">
                                                    <v-text-field
                                                        v-model="lieferscheinReportData.createdAt__lte"
                                                        label="Do"
                                                        prepend-icon="mdi-calendar"
                                                        readonly
                                                        solo
                                                        hide-details
                                                        append-icon
                                                        clearable
                                                        class="mt-0"
                                                        v-on="on"
                                                        @click:clear="clearLieferscheinReportData('createdAt__lte')"
                                                    >
                                                        <template slot="append-outer">
                                                            <div class="d-flex flex-wrap">
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    class="mt-n2"
                                                                    data-sentry-label="Zmiana końca daty raportu - +1"
                                                                    @click="getLieferscheinForwardDate('createdAt__lte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-up
                                                                    </v-icon>
                                                                </v-btn>
                                                                <v-btn
                                                                    icon
                                                                    x-small
                                                                    data-sentry-label="Zmiana końca daty raportu - -1"
                                                                    @click="getLieferscheinBackwardDate('createdAt__lte')"
                                                                >
                                                                    <v-icon>
                                                                        mdi-chevron-down
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="lieferscheinReportData.createdAt__lte"
                                                    first-day-of-week="1"
                                                    @input="menuLieferscheinTo = false"
                                                />
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        :disabled="!lieferscheinReportData.createdAt__lte || !lieferscheinReportData.createdAt__gte"
                                        :loading="actionLoading.generateLieferscheinReport"
                                        @click="generateLieferscheinReport"
                                    >
                                        Generuj raport
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import { required } from 'vuelidate/lib/validators'
import dateFormatter from '@/mixins/dateFormatter'

import OrdersListDialog from './OrdersListDialog'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'

export default {
    name: 'Orders',
    components: {
        PageTitle,
        OrdersListDialog
    },
    mixins: [
        dateFormatter
    ],
    data() {
        return {
            orderStatusesReportData: {
                plannedSendDate__lte: null,
                plannedSendDate__gte: null,
                userEmail: null,
            },
            lieferscheinReportData: {
                createdAt__lte: null,
                createdAt__gte: null,
                userEmail: null,
            },
            menuFrom: false,
            menuTo: false,
            menuLieferscheinFrom: false,
            menuLieferscheinTo: false,
            orderNumber: null,
            ordersListLoading: false,
            ordersListDialog: false,
            actionLoading: {
                generateReport: false,
                generateLieferscheinReport: false
            },
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
    },
    validations: {
        orderNumber: {
            required
        }
    },
    mounted() {
        Promise.all([
            this.getUser(),
        ])
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        clearOrderStatusesReportData(filterName) {
            this.orderStatusesReportData[filterName] = null
        },
        clearLieferscheinReportData(filterName) {
            this.lieferscheinReportData[filterName] = null
        },
        getUser() {
            this.$store.dispatch('administration/getUser', this.userId)
                .then(response => {
                    this.user = response.data,
                    this.setReportDataEmail()
                })
        },
        setReportDataEmail() {
            this.orderStatusesReportData.userEmail = this.user.email
            this.lieferscheinReportData.userEmail = this.user.email
        },
        getBackwardDate(plannedSendDate) {
            if (Date.parse(this.orderStatusesReportData[plannedSendDate])) {
                this.orderStatusesReportData[plannedSendDate] = this.getDayBackward(this.orderStatusesReportData[plannedSendDate])
            }
        },
        getForwardDate(plannedSendDate) {
            if (Date.parse(this.orderStatusesReportData[plannedSendDate])) {
                this.orderStatusesReportData[plannedSendDate] = this.getDayForward(this.orderStatusesReportData[plannedSendDate])
            }
        },
        getLieferscheinBackwardDate(createdAt) {
            if (Date.parse(this.lieferscheinReportData[createdAt])) {
                this.lieferscheinReportData[createdAt] = this.getDayBackward(this.lieferscheinReportData[createdAt])
            }
        },
        getLieferscheinForwardDate(createdAt) {
            if (Date.parse(this.lieferscheinReportData[createdAt])) {
                this.lieferscheinReportData[createdAt] = this.getDayForward(this.lieferscheinReportData[createdAt])
            }
        },
        generateOrderStatusesReport() {
            this.actionLoading.generateReport = true
            this.$store.dispatch('reportsAndAnalysis/reports/generateOrderStatusesReport', this.orderStatusesReportData)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.generateReport = false
                })
        },
        generateLieferscheinReport() {
            this.actionLoading.generateLieferscheinReport = true
            this.$store.dispatch('reportsAndAnalysis/reports/generateLieferscheinReport', this.lieferscheinReportData)
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.generateLieferscheinReport = false
                })
        },
        openReport(report) {
            this.$router.push({ name: report })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showOrdersListDialog() {
            this.ordersListLoading = true
            this.ordersListDialog = true
            addSentryBreadcrumb('ui.action', 'Lista zamówień')
        },
        closeOrdersListDialog() {
            this.ordersListDialog = false
            this.ordersListLoading = false
        }
    }
}
</script>